import { TableSchema } from '../metadata-schema';

export const la_leerling_autorisatie: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "la_leerling_autorisatie",
	"description": "Definitie voor sys tabel la_leerling_autorisatie uit de CumLaude sys",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.SysTable",
		"nl.topicus.cumlaude.metadata.table.Instellingspecifiek"
	],
	"abbrev": "la",
	"properties": {}
};
